import React from 'react';
import classNames from 'classnames';

import * as styles from './index.module.scss';

type Props = {
  inverted?: boolean;
};

export const Loader: React.FC<Props> = ({ inverted }) => {
  return (
    <div className={classNames(styles.loader, inverted && styles.inverted)} />
  );
};
